export enum AccountStatus {
  SIGNUP_LITE = 'SIGNUP_LITE', //create zoho and zen accounts
  REWARDS_SIGNUP = 'REWARDS_SIGNUP', //create zen account
  ACTIVATE_REWARDS = 'ACTIVATE_REWARDS', //redirect to login with rewards acitvation flow
  NO_LITE_SIGNUP = 'NO_LITE_SIGNUP', //no action
}
